export default function PraSettingsDialogController(
  $rootScope,
  $scope,

  alerts,
  ssDialogService,
  loaderService,
  praDataService,
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveSettings = _handleSaveSettings;
  vm.handleExpandSettingsSection = _handleExpandSettingsSection;

  _activate();

  // //////// METHODS //////////


  function _activate() {
    // eslint-disable-next-line max-len
    vm.appetiteLevelToolTip = 'Risk Appetite levels are defined as a reduction in Inherent Risk, i.e. if you assign a value of "10" to the "Very Low" Risk Appetite, you would need to reduce your Residual Risk level to no more than 10% of your Inherent Risk';
    _initRiskAppetiteLevels();
  }

  function _initRiskAppetiteLevels() {
    vm.lowRiskAppetiteLevel = vm.settings.customerRiskAppetiteLevels.find(
      riskAppetite => riskAppetite.riskAppetiteLevelId === 1
    );
    vm.mediumRiskAppetiteLevel = vm.settings.customerRiskAppetiteLevels.find(
      riskAppetite => riskAppetite.riskAppetiteLevelId === 2
    );
    vm.highRiskAppetiteLevel = vm.settings.customerRiskAppetiteLevels.find(
      riskAppetite => riskAppetite.riskAppetiteLevelId === 3
    );
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pra.settingsDialog);
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleSaveSettings() {
    if ($scope.editPRASettingsForm.$valid) {
      loaderService.showViewLoader = true;
      return praDataService.saveSettings(vm.settings).then(() => {
        loaderService.showViewLoader = false;
        alerts.success('The PRA Settings has been saved successfully.');
        $rootScope.$broadcast('refreshPRAAssessments');
        _closeDialog();
      });
    }
  }

  // Expand/Collapse
  function _handleExpandSettingsSection($event, section) {
    vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
  }
}

PraSettingsDialogController.$inject = [
  '$rootScope',
  '$scope',

  'alerts',
  'ssDialogService',
  'loaderService',
  'praDataService',
];
